/* ===========================================================
   3DFX Store — theme JS
   Vanilla, progressive enhancement only. Every page works
   without JavaScript; this layer just makes it nicer.
   =========================================================== */
(function () {
  "use strict";

  var root = document.documentElement;

  // Only opt into the reveal animation if we can actually run it.
  if ("IntersectionObserver" in window) root.classList.add("js-ready");

  var money = function (cents) {
    var format = (window.THEME && window.THEME.moneyFormat) || "£{{amount}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var withComma = parts.join(".");
    var noDecimals = parts[0];
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  };

  /* -------------------------------------------------------
     Sticky header state
     ------------------------------------------------------- */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* -------------------------------------------------------
     Mobile navigation
     ------------------------------------------------------- */
  var navToggle = document.querySelector("[data-nav-toggle]");
  var navLinks = document.querySelector("[data-nav-links]");
  if (navToggle && navLinks) {
    navToggle.addEventListener("click", function () {
      var open = navLinks.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", String(open));
    });
    navLinks.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        navLinks.classList.remove("open");
        navToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* -------------------------------------------------------
     Search overlay
     ------------------------------------------------------- */
  var searchOverlay = document.querySelector("[data-search-overlay]");
  if (searchOverlay) {
    var openSearch = function () {
      searchOverlay.classList.add("open");
      var input = searchOverlay.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 40);
    };
    var closeSearch = function () { searchOverlay.classList.remove("open"); };

    Array.prototype.forEach.call(document.querySelectorAll("[data-search-open]"), function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });
    Array.prototype.forEach.call(searchOverlay.querySelectorAll("[data-search-close]"), function (btn) {
      btn.addEventListener("click", closeSearch);
    });
    searchOverlay.addEventListener("click", function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeSearch();
    });
  }

  /* -------------------------------------------------------
     Custom order fields (line item properties)
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-char-count]"), function (counter) {
    var field = counter.closest(".field");
    var input = field && field.querySelector("[data-custom-field]");
    if (!input) return;

    var max = parseInt(counter.getAttribute("data-max"), 10) || 0;
    var update = function () {
      var len = input.value.length;
      counter.textContent = len + "/" + max;
      if (max > 0 && len > max * 0.85) {
        counter.classList.add("is-near");
      } else {
        counter.classList.remove("is-near");
      }
    };
    input.addEventListener("input", update);
    update();
  });

  /* -------------------------------------------------------
     Scroll reveal
     ------------------------------------------------------- */
  var revealObserver = null;
  if ("IntersectionObserver" in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
  }

  function observeReveals(scope) {
    if (!revealObserver) return;
    var els = (scope || document).querySelectorAll(".reveal:not(.in)");
    Array.prototype.forEach.call(els, function (el) { revealObserver.observe(el); });
  }

  observeReveals(document);

  /* -------------------------------------------------------
     Horizontal carousels (testimonials etc.)
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-carousel]"), function (carousel) {
    var track = carousel.querySelector("[data-carousel-track]");
    var prev = carousel.querySelector("[data-carousel-prev]");
    var next = carousel.querySelector("[data-carousel-next]");
    if (!track || !prev || !next) return;

    var stepSize = function () {
      var card = track.firstElementChild;
      return card ? card.offsetWidth + 20 : track.clientWidth;
    };
    prev.addEventListener("click", function () { track.scrollBy({ left: -stepSize(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: stepSize(), behavior: "smooth" }); });
  });

  /* -------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-change]");
    if (!btn) return;
    var wrap = btn.closest(".qty");
    if (!wrap) return;
    var input = wrap.querySelector("input");
    if (!input) return;

    var min = parseInt(input.getAttribute("min") || "1", 10);
    var current = parseInt(input.value, 10) || min;
    var delta = btn.getAttribute("data-qty-change") === "up" ? 1 : -1;
    var nextVal = Math.max(min, current + delta);

    input.value = nextVal;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* -------------------------------------------------------
     Product media gallery
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-gallery]"), function (gallery) {
    var slides = gallery.querySelectorAll("[data-media-id]");
    var thumbs = gallery.querySelectorAll("[data-media-target]");

    var show = function (id) {
      Array.prototype.forEach.call(slides, function (slide) {
        slide.classList.toggle("is-active", slide.getAttribute("data-media-id") === id);
      });
      Array.prototype.forEach.call(thumbs, function (thumb) {
        var active = thumb.getAttribute("data-media-target") === id;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-current", active ? "true" : "false");
      });
    };

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener("click", function () {
        show(thumb.getAttribute("data-media-target"));
      });
    });

    gallery.addEventListener("theme:variant:change", function (e) {
      if (e.detail && e.detail.featuredMediaId) show(String(e.detail.featuredMediaId));
    });
  });

  /* -------------------------------------------------------
     Variant picker
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-variant-picker]"), function (picker) {
    var dataEl = document.querySelector("#variant-data-" + picker.getAttribute("data-product-id"));
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = document.querySelector("#product-form-" + picker.getAttribute("data-product-id"));
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.querySelector("[data-product-price]");
    var stockEl = document.querySelector("[data-product-stock]");
    var submitEl = form ? form.querySelector('[data-add-to-cart]') : null;
    var skuEl = document.querySelector("[data-product-sku]");
    var gallery = document.querySelector("[data-gallery]");

    var selectedOptions = function () {
      return Array.prototype.map.call(
        picker.querySelectorAll("[data-option-index]"),
        function (group) {
          var checked = group.querySelector("input:checked");
          return checked ? checked.value : null;
        }
      );
    };

    var update = function () {
      var chosen = selectedOptions();
      var match = null;

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] !== null && v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }

      if (!match) {
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.textContent = (window.THEME && window.THEME.strings.unavailable) || "Unavailable";
        }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        var html = '<span class="price__current">' + money(match.price) + "</span>";
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="price__compare">' + money(match.compare_at_price) + "</span>";
          priceEl.classList.add("price--on-sale");
        } else {
          priceEl.classList.remove("price--on-sale");
        }
        priceEl.innerHTML = html;
      }

      if (stockEl) {
        stockEl.className = "stock" + (match.available ? "" : " stock--out");
        stockEl.innerHTML = "<i></i>" + (match.available
          ? ((window.THEME && window.THEME.strings.inStock) || "In stock")
          : ((window.THEME && window.THEME.strings.soldOut) || "Sold out"));
      }

      if (skuEl) skuEl.textContent = match.sku || "";

      if (submitEl) {
        submitEl.disabled = !match.available;
        submitEl.textContent = match.available
          ? ((window.THEME && window.THEME.strings.addToCart) || "Add to cart")
          : ((window.THEME && window.THEME.strings.soldOut) || "Sold out");
      }

      if (gallery && match.featured_media_id) {
        gallery.dispatchEvent(new CustomEvent("theme:variant:change", {
          detail: { featuredMediaId: match.featured_media_id }
        }));
      }

      // Keep the URL shareable without a page reload.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        window.history.replaceState({}, "", url.toString());
      }
    };

    picker.addEventListener("change", update);
  });

  /* -------------------------------------------------------
     Cart count refresh
     ------------------------------------------------------- */
  var refreshCartCount = function (count) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-cart-count]"), function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  /* -------------------------------------------------------
     Add to cart (AJAX with graceful fallback)
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("form.product-form"), function (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return; // let the browser post normally

      // form.elements also covers inputs attached via the form="" attribute,
      // which is how the custom order fields sit outside the form markup.
      var els = Array.prototype.slice.call(form.elements);

      // A file upload has to go through a normal form post — the AJAX cart
      // would drop it, and the customer needs the full page response anyway.
      var hasFile = els.some(function (el) {
        return el.type === "file" && el.files && el.files.length > 0;
      });
      if (hasFile) return;

      e.preventDefault();

      var btn = form.querySelector("[data-add-to-cart]");
      var original = btn ? btn.textContent : "";
      var status = form.querySelector("[data-form-status]");

      if (btn) { btn.disabled = true; btn.textContent = (window.THEME && window.THEME.strings.adding) || "Adding…"; }
      if (status) { status.hidden = true; }

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data.description || result.data.message);
          return fetch(window.Shopify.routes.root + "cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          refreshCartCount(cart.item_count);
          if (status) {
            status.className = "notice notice--success";
            status.innerHTML = '<span>' +
              ((window.THEME && window.THEME.strings.added) || "Added to your cart.") +
              ' <a href="' + window.Shopify.routes.root + 'cart">' +
              ((window.THEME && window.THEME.strings.viewCart) || "View cart") + "</a></span>";
            status.hidden = false;
          }
        })
        .catch(function (err) {
          if (status) {
            status.className = "notice notice--error";
            status.innerHTML = "<span>" + (err.message || "That item couldn't be added.") + "</span>";
            status.hidden = false;
          }
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* -------------------------------------------------------
     Cart page: live quantity changes & removal
     ------------------------------------------------------- */
  var cartRoot = document.querySelector("[data-cart-root]");
  if (cartRoot && window.fetch) {
    var updateLine = function (key, quantity) {
      cartRoot.setAttribute("aria-busy", "true");
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    };

    cartRoot.addEventListener("change", function (e) {
      var input = e.target.closest("[data-cart-qty]");
      if (!input) return;
      updateLine(input.getAttribute("data-line-key"), parseInt(input.value, 10) || 0);
    });

    cartRoot.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cart-remove]");
      if (!btn) return;
      e.preventDefault();
      updateLine(btn.getAttribute("data-line-key"), 0);
    });
  }

  /* -------------------------------------------------------
     Facet forms: auto-submit on change
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-auto-submit]"), function (form) {
    form.addEventListener("change", function () { form.submit(); });
  });

  /* -------------------------------------------------------
     Footer year
     ------------------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-current-year]"), function (el) {
    el.textContent = new Date().getFullYear();
  });
  document.addEventListener("shopify:section:load", function (e) {
    observeReveals(e.target);
  });

  document.addEventListener("shopify:section:select", function (e) {
    observeReveals(e.target);
  });

  document.addEventListener("shopify:block:select", function (e) {
    observeReveals(e.target.closest("section") || document);
  });

})();
